import {
  CurrencyCode,
  ExchangeRateQuery,
  ExchangeRateQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

export const exchangeRateQuery = gql`
  query ExchangeRate($currencyCode: CurrencyCode!) {
    exchangeRate(currencyCode: $currencyCode) {
      uid
      currency_code
      exchange_rate
    }
  }
`;

export function useExchangeRate(currencyCode: CurrencyCode) {
  const skip = !currencyCode || currencyCode === CurrencyCode.Usd;
  const { loading, error, data } = useQueryWithPreviousData<
    ExchangeRateQuery,
    ExchangeRateQueryVariables
  >(exchangeRateQuery, {
    skip,
    variables: { currencyCode },
  });

  if (skip) {
    return { loading: false, error: null, exchangeRate: 1 };
  }

  const exchangeRate = data?.exchangeRate?.exchange_rate ?? 1;
  return { loading, error, exchangeRate };
}
